import React from 'react'
import './webStats.css'
import OrdersListTab from '../OrdersListTab/OrdersListTab'
import PerformanceTab from '../performanceTab/performanceTab';
import { useDashboardData } from '../../../Context/DashboardContext/dashboardContext';
import { formatTimestamp } from '../../../Services/Api';

const WebStats = () => {
  const { orderInsights, loading, error, fetchInsights, performanceHistory } = useDashboardData();
  const SCORE_RANGES = {
    GREEN: 70,  // 70 and above
    ORANGE: 51, // 51 - 69
    RED: 0      // 0 - 50
  };
  return (
    <div className='recent-orders-main-container'>
      <h3>Website Performance</h3>
      <div className='recent_orders'>
        <PerformanceTab is_header={true} dateTime={"Date & Time"} device={"Device"} url={"URL"} score={"Score"} />
        {performanceHistory && performanceHistory?.map((item) => {
          return (
            <PerformanceTab
              is_header={false}
              dateTime={formatTimestamp(item.createdAt)}
              device={item.device}
              url={item.url}
              score={item.score}
              class_name={
                item.score >= SCORE_RANGES.GREEN ? "green" :
                  item.score >= SCORE_RANGES.ORANGE ? "orange" :
                    "red"
              }
            />
          )
        })}
      </div>
    </div>
  )
}

export default WebStats
